import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'importStatus',
})
export class ImportStatusPipe implements PipeTransform {
  transform(value: string): string {
    return (
      {
        inProgress: '正在导入',
        success: '已完成',
        failed: '失败',
        duplicate: '文件重复',
        canceled: '已取消',
      }[value] || value
    );
  }
}
